import { render, staticRenderFns } from "./WarningConfirmOld.vue?vue&type=template&id=47021ff8&scoped=true&"
import script from "./WarningConfirmOld.vue?vue&type=script&lang=ts&"
export * from "./WarningConfirmOld.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47021ff8",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});qInstall(component, 'directives', {ClosePopup});
